// NPM Requirements
import _ from 'lodash';
import cn from 'classnames';
import geolib from 'geolib';
import GoogleMapReact from 'google-map-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import BookAFoodTruck from './BookAFoodTruck';
import MapMarker from './MapMarker';
import MapMarkerHover from './MapMarkerHover';

import { loaderOptions } from '../../modules/googleMapsUtils';

import styles from './SearchMap.module.postcss';

export default class SearchMap extends Component {
  constructor(props) {
    super(props);
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.onMarkerClose = this.onMarkerClose.bind(this);

    this.state = {
      shownLocation: null,
    };
  }

  onMarkerClick(key) {
    this.setState({ shownLocation: key });
  };

  onMarkerClose() {
    this.setState({ shownLocation: null });
  }

  getSelectedLocation() {
    const { locations } = this.props;
    const { shownLocation } = this.state;

    const selectedLocation = _.find(locations, (location) => {
      const locationKey = `map-marker-${location.id}`;
      return locationKey === shownLocation;
    });
    return selectedLocation;
  }

  getLocationMarkers() {
    const { center, locations } = this.props;
    const { shownLocation } = this.state;

    let sortedLocations = _.filter(locations, (location) => {
      return location.latitude && location.longitude;
    })
    sortedLocations = geolib.orderByDistance({
      latitude: center.lat,
      longitude: center.lng
    }, sortedLocations);

    return sortedLocations.map((sortedLocation) => {
      const location = locations[sortedLocation.key];
      const locationKey = `map-marker-${location.id}`;

      return (
        <MapMarker
          history={this.props.history}
          key={locationKey}
          lat={location.latitude}
          lng={location.longitude}
          location={location}
          show={shownLocation === locationKey}
          onClose={this.onMarkerClose}
        />
      );
    });
  }

  render() {
    const { center, geolocating, mapHasLoaded, mapOptions, onGeolocate, onMapChange, zoom } = this.props;
    const { shownLocation } = this.state;

    return (
      <div className="MapWithList-map-inner">
        {mapHasLoaded && (
          <GoogleMapReact
            bootstrapURLKeys={loaderOptions}
            center={center}
            zoom={zoom}
            onChange={onMapChange}
            options={mapOptions}
            hoverDistance={18}
            resetBoundsOnResize
            onChildClick={this.onMarkerClick}
          >
            {this.getLocationMarkers()}
          </GoogleMapReact>
        )}

        <BookAFoodTruck />

        {/* For Mobile */}
        { shownLocation &&
          <MapMarkerHover
            location={this.getSelectedLocation()}
            onClose={this.onMarkerClose}
          />
        }

        <button
          onClick={onGeolocate}
          className={cn({
            [styles.GeolocateButton]: true,
            [styles.GeolocateButton__locating]: geolocating
          })}
        >
          <svg viewBox="0 0 652 652" >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <circle className={styles.GeolocateButton_background} fill="#FFFFFF" cx="326" cy="326" r="326"></circle>
              <path className={styles.GeolocateButton_icon} d="M326,523 C217.199904,523 129,434.800096 129,326 C129,217.199904 217.199904,129 326,129 C434.800096,129 523,217.199904 523,326 C523,434.800096 434.800096,523 326,523 Z M326,481 C411.604136,481 481,411.604136 481,326 C481,240.395864 411.604136,171 326,171 C240.395864,171 171,240.395864 171,326 C171,411.604136 240.395864,481 326,481 Z" id="Oval" fill="#535353" fillRule="nonzero"></path>
              <polygon className={styles.GeolocateButton_icon} fill="#535353" fillRule="nonzero" points="305 70 305 230 347 230 347 70"></polygon>
              <polygon className={styles.GeolocateButton_icon} fill="#535353" fillRule="nonzero" points="305 422 305 582 347 582 347 422"></polygon>
              <polygon className={styles.GeolocateButton_icon} fill="#535353" fillRule="nonzero" points="422 347 582 347 582 305 422 305"></polygon>
              <polygon className={styles.GeolocateButton_icon} fill="#535353" fillRule="nonzero" points="70 347 230 347 230 305 70 305"></polygon>
              <path className={styles.GeolocateButton_icon} d="M326,397 C286.787783,397 255,365.212217 255,326 C255,286.787783 286.787783,255 326,255 C365.212217,255 397,286.787783 397,326 C397,365.212217 365.212217,397 326,397 Z M326,355 C342.016258,355 355,342.016258 355,326 C355,309.983742 342.016258,297 326,297 C309.983742,297 297,309.983742 297,326 C297,342.016258 309.983742,355 326,355 Z" id="Oval" fill="#535353" fillRule="nonzero"></path>
            </g>
          </svg>
          <span>Near me</span>
        </button>
      </div>
    );
  }
}

SearchMap.propTypes = {
  center: PropTypes.object,
  geolocating: PropTypes.bool,
  locations: PropTypes.array,
  mapHasLoaded: PropTypes.bool,
  mapOptions: PropTypes.object,
  onGeolocate: PropTypes.func,
  onMapChange: PropTypes.func,
  zoom: PropTypes.number,
  history: PropTypes.object,
};
